module.exports = __webpack_public_path__ + "img/img-109.119d2551.png";